export const IndustryTypes = [
  "Transport, Courier & Logistics",
  "Manufacturing & Industrial Production",
  "Chemicals, Plastics & Materials",
  "Wholesale & Distribution",
  "Construction & Built Environment",
  "Professional, Design & Digital Services",
  "Energy, Utilities & Resources",
  "Agriculture, Forestry & Food System",
  "Retail, Hospitality & Consumer Services",
  "Healthcare, Education & Public Services",
  "Waste & Environmental Services",
  "Arts, Media, Sport & Entertainment",
  "Others (Editable)",
];

export const StructureTypes = IndustryTypes;
